import { RouteConfig } from 'vue-router'
import Main from '../Company/Main.vue'

export const companyRoutes: RouteConfig = {
  path: '/company',
  name: 'company',
  component: Main
}
